export const getUserPlatform = (): 'macOs' | 'Windows' | undefined => window.navigator['userAgentData']?.platform;
